export const sortBetsBySettlementDate = function (a, b) {
    return new Date(b.settlementDate).getTime() - new Date(a.settlementDate).getTime();
};
//# sourceMappingURL=sortBetsBySettlementDate.js.map